import React, { useState } from 'react';

interface StepProps {
  handleInputChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  formData: {
    bidRequests: string;
    [key: string]: string;
  };
}

const QualityStep: React.FC<StepProps> = ({ handleInputChange, formData }) => {
  const [includeLongtail, setIncludeLongtail] = useState(true);
  const [selectedQualityScore, setSelectedQualityScore] = useState("all-websites");

  const handleCheckboxChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setIncludeLongtail(event.target.checked);
  };

  const handleSelectChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
    const value = event.target.value;
    setSelectedQualityScore(value);
    if (value === "all-websites") {
      setIncludeLongtail(false); // Disable checkbox when "All websites" is selected
    }
  };

  return (
    <div style={{ fontFamily: 'Arial, sans-serif', maxWidth: '600px', padding: '20px' }}>
      <div style={{ display: 'flex', gap: '50px', alignItems: 'center' }}>
        <label
          htmlFor="qualityScore"
          style={{
            width: '300px',
            fontWeight: 'bold',
            fontSize: '13px',
            display: 'block',
            marginBottom: '10px',
          }}
        >
          Select quality score:
        </label>
        <select
          id="qualityScore"
          style={{
            width: '100%',
            padding: '8px',
            fontSize: '14px',
            marginBottom: '20px',
            borderRadius: '4px',
            border: '1px solid #ccc',
          }}
          value={selectedQualityScore}
          onChange={handleSelectChange}
        >
          <option value="all-websites">All websites</option>
          <option value="high-quality">Top 10% of websites (Highest Quality - 9+)</option>
          <option value="medium-quality">Top 20% of websites - 8+</option>
          <option value="medium-quality">Top 30% of websites - 7+</option>
          <option value="low-quality">Top 40% of websites - 6+</option>
          <option value="low-quality">Top 50% of websites - 5+</option>
          <option value="low-quality">Top 60% of websites - 4+</option>
          <option value="low-quality">Top 70% of websites - 3+</option>
          <option value="low-quality">Top 80% of websites - 2+</option>
          <option value="low-quality">Top 90% of websites - 1+</option>
        </select>
      </div>

      <div style={{ marginBottom: '20px' }}>
        <input
          type="checkbox"
          id="includeLongtail"
          checked={includeLongtail}
          onChange={handleCheckboxChange}
          disabled={selectedQualityScore === "all-websites"}
          style={{ marginRight: '10px' }}
        />
        <label htmlFor="includeLongtail" style={{ fontSize: '14px' }}>
          Include longtail traffic sources
        </label>
      </div>
      <p style={{ fontSize: '14px', color: '#555', lineHeight: '1.5' }}>
        Quality score is an average calculated by actual ROI of our advertisers.
      </p>
      <p style={{ fontSize: '14px', color: '#555', lineHeight: '1.5' }}>
        However, please choose carefully because not every website works the same for every advertiser, so there are very
        high chances that many websites that are scored low can perform very well for you. The higher score you choose, the
        less traffic you will get — and it will be more expensive. You can change this anytime by clicking the "Targeting" button.
      </p>
    </div>
  );
};

export default QualityStep;
